import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../contexts/GlobalStateContext";

const Explore = () => {
  const [contextOffset, setContextOffset] = useState(null); // Start with null to avoid auto-fetch
  const [contextLimit] = useState(20); // Load 20 contexts per request
  const [exploreData, setExploreData] = useState([]); // All fetched contexts
  const [hasMore, setHasMore] = useState(true); // More posts available?
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const { globalState, setShowExplore } = useGlobalState();
  const [selectedContext, setSelectedContext] = useState(null);
  const exploreRef = useRef(null); // Reference to the explore menu

  // Load explore data when contextOffset changes
  useEffect(() => {
    if (contextOffset !== null) {
      loadExplore(contextOffset);
    }
  }, [contextOffset]);

  // Set offset to 0 on initial mount to trigger first load
  useEffect(() => {
    setContextOffset(0);

    const handleClickOutside = (event) => {
      if (exploreRef.current && !exploreRef.current.contains(event.target)) {
        if (!globalState.showExplore) {
          closeMenu();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const loadExplore = async (offset) => {
    try {
      const response = await fetch(`${baseUrl}/php/explore.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ offset, limit: contextLimit }),
      });

      const data = await response.json();

      if (data.success) {
        if (data.posts.length < contextLimit) {
          setHasMore(false);
        }
        setExploreData((prevData) => [...prevData, ...data.posts]);
      } else {
        console.error("Failed to load posts:", data.message);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const handleContextClick = (context) => {
    setSelectedContext(context);
    closeMenu();
  };

  useEffect(() => {
    if (selectedContext) {
      navigate(`/context?query=${encodeURIComponent(selectedContext)}`);
    }
  }, [selectedContext]);

  const handleViewMore = () => {
    setContextOffset((prevOffset) => prevOffset + contextLimit);
  };

  const closeMenu = () => {
    setShowExplore(false);
  };

  return (
    <div>
      {globalState.showExplore && (
        <div id="menuSideNav" className="explore_nav" ref={exploreRef}>
          <span className="explore_label">Explore</span>
          <a className="closebtn" onClick={closeMenu}>
            &times;
          </a>
          <div id="explore">
            {exploreData.map((post, index) => (
              <div key={index} className="explore">
                <span
                  className="contexts"
                  data-context={post.context}
                  onClick={() => handleContextClick(post.context)}
                >
                  {post.context}
                </span>
              </div>
            ))}
          </div>
          {hasMore ? (
            <button
              className="explore full_textbox"
              style={{ cursor: "pointer", marginBottom: "80px" }}
              onClick={handleViewMore}
            >
              View More
            </button>
          ) : (
            <div style={{ height: "101px" }}></div>
          )}
        </div>
      )}
    </div>
  );
};

export default Explore;
